import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-24 bg-emerald-900 relative" data-id="element-150">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-151">
        <FadeIn data-id="element-152">
          <div className="prose prose-lg prose-invert mx-auto text-center md:text-left" data-id="element-153">
            <p className="text-xl md:text-2xl leading-relaxed text-emerald-50 font-body mb-8" data-id="element-154">
              Te miras al espejo después de una semana de{' '}
              <span className="text-gold-400 font-semibold" data-id="element-155">
                pavo, brócoli y sesiones intensas de HIIT
              </span>
              ... y sigues inflamada. Tus leggings te dejan una marca profunda
              en la cintura y sientes que tu cuerpo está reteniendo cada gramo
              de agua como un mecanismo de defensa.
            </p>

            <p className="text-xl md:text-2xl leading-relaxed text-emerald-50/80 font-body" data-id="element-156">
              No es falta de voluntad. No es que "no estés entrenando lo
              suficiente". Es que estás forzando a tu biología a trabajar en un{' '}
              <span className="text-gold-400 font-semibold border-b border-gold-400/30 pb-1" data-id="element-157">
                estado de estrés constante 24/7
              </span>
              .
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}